import { render, staticRenderFns } from "./SalesForcastTableForLazyLoadingWithResize.vue?vue&type=template&id=30a0f4d8"
import script from "./SalesForcastTableForLazyLoadingWithResize.vue?vue&type=script&lang=js"
export * from "./SalesForcastTableForLazyLoadingWithResize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports